<template>
  <div class="dialog-add-account__form-item">
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.vat_settings') }}
    </div>
    <label v-for="platform in platforms" :key="platform.key" class="input__item-checkbox">
      <input
        type="checkbox"
        :checked="value[platform.key]"
        :disabled="disabled"
        @change="handleChange(platform.key, $event.target.checked)"
      />
      <span class="input__item-checkbox__check">
        <img src="@/assets/icons/icon-done.svg" />
      </span>
      <span class="input__item-checkbox__info">
        <span class="input__item-checkbox__title" v-html="$t(platform.i18nKey)"> </span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'VatSettings',
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      platforms: [
        {
          key: 'yandex',
          i18nKey: 'business_account_data.yandex_vat',
        },
        {
          key: 'yandexbusiness',
          i18nKey: 'business_account_data.yandexbusiness_vat',
        },
        {
          key: 'vkads',
          i18nKey: 'business_account_data.vk_add_vat',
        },
        {
          key: 'google',
          i18nKey: 'business_account_data.google_vat',
        },
        {
          key: 'telegram',
          i18nKey: 'business_account_data.telegram_vat',
        },
        {
          key: 'promopages',
          i18nKey: 'business_account_data.promopages_vat',
        },
        {
          key: 'metricapro',
          i18nKey: 'business_account_data.metricapro_vat',
        },
        {
          key: 'mediaplatform',
          i18nKey: 'user_data.mediaplatform_vat',
        },
        {
          key: 'vkadblogger',
          i18nKey: 'user_data.vkadblogger_vat',
        },
        {
          key: 'ozon',
          i18nKey: 'Работа с <span>Ozon</span> с НДС',
        },
        {
          key: 'avito',
          i18nKey: 'Работа с <span>Avito</span> с НДС',
        },
        {
          key: 'urbanads',
          i18nKey: 'user_data.urbanads_vat',
        },
      ],
    };
  },
  methods: {
    handleChange(key, checked) {
      const updated = { ...this.value };
      this.$set(updated, key, checked);
      this.$emit('input', updated);
    },
  },
};
</script>
